import { apply, call, put, select, takeEvery } from 'redux-saga/effects';
import * as Types from './../actions/constants';
import personasActions from './../actions/personasActions';
import feathers from './../../services/FeathersService';
import {
  personaValidator
} from './../../services/validators';

const PersonasService = feathers.service('api/personas');

function* findPersonas () {
  try {
    let response = yield call([PersonasService, 'find']);

    yield put(personasActions.findSuccess(response.records, response.total));
  } catch (e) {
    yield put(personasActions.findFailure(e));
  }
}

function* upsertPersona ({ payload }) {
  try {
    let persona = yield call([PersonasService, 'create'], payload.values);

    yield put(personasActions.upsertSuccess(persona));
    yield put(personasActions.resetForm());
    yield put(personasActions.toggleUpsertModal());
    yield put(personasActions.findAttempt());
  } catch (e) {
    yield put(personasActions.upsertFailure(e));
  }
}

export default function* watchUsersActions () {
  yield takeEvery(Types.FIND_PERSONAS_ATTEMPT, findPersonas);
  yield takeEvery(Types.UPSERT_PERSONA_ATTEMPT, upsertPersona);
}


// WEBPACK FOOTER //
// ./client/store/sagas/personasSaga.js